import React from "react";
import LegalPage from "../Legal/LegalPage";

const intro = [
  "This website is operated by MAXXTEK SOLUTIONS. References to “we”, “us”, and “our” mean MAXXTEK SOLUTIONS. We provide this website, its information, tools, and services subject to your acceptance of these terms, conditions, policies, and notices.",
  "By visiting the website or purchasing from us, you use our Service and agree to these Terms of Service and any policies referenced here. These terms apply to every site user, including browsers, customers, vendors, merchants, and content contributors.",
  "Please review these terms before accessing the website. Using any part of the site means you accept them. New features and tools are also governed by these terms, and continued use after an update constitutes acceptance of the updated terms.",
];

const sections = [
  {
    title: "Online store terms",
    paragraphs: [
      "You confirm that you are at least the age of majority where you live, or that you have consented to allow your minor dependants to use this site.",
      "Products and services must not be used for unlawful or unauthorized purposes. You must not violate applicable laws, transmit viruses, worms, or destructive code. A breach may result in immediate termination of Service.",
    ],
  },
  {
    title: "General conditions",
    paragraphs: [
      "We may refuse service to anyone at any time for any reason. Content other than card information may travel unencrypted across networks and be adapted to technical requirements; card information is encrypted during network transfer.",
      "You may not reproduce, duplicate, copy, sell, resell, or exploit the Service, access to it, or website contacts without our written permission. Section headings are provided for convenience and do not limit these terms.",
    ],
  },
  {
    title: "Accuracy, completeness, and timeliness",
    paragraphs: [
      "Website material is provided for general information and may not always be accurate, complete, or current. Decisions should be based on appropriate primary or up-to-date sources. Historical information is for reference only, and you are responsible for monitoring site changes.",
    ],
  },
  {
    title: "Changes to services and prices",
    paragraphs: [
      "Product prices may change without notice. We may modify, suspend, or discontinue all or part of the Service at any time and are not liable for resulting modifications, price changes, suspensions, or discontinuations.",
    ],
  },
  {
    title: "Products or services",
    paragraphs: [
      "Some products or services may be available only online, may have limited availability, and are subject to the applicable return policy. We try to present product information accurately but cannot guarantee how colours or images appear on every device.",
      "We may limit sales by person, location, jurisdiction, or quantity; change descriptions or prices; discontinue products; and void offers where prohibited. We do not guarantee that every purchased product, service, or item of information will meet expectations or that every Service error will be corrected.",
    ],
  },
  {
    title: "Billing and account information",
    paragraphs: [
      "We may refuse, limit, or cancel orders, including orders connected by account, card, billing address, or shipping address. If an order changes or is cancelled, we may use the contact information provided with the order to notify you.",
      "You agree to provide accurate and current purchase and account details and to update information, including email addresses and payment-card details, when necessary. Please also review the applicable return and refund policy.",
    ],
  },
  {
    title: "Optional tools",
    paragraphs: [
      "Third-party tools may be made available without our monitoring or control. They are provided as available and without warranties or endorsement. Use is at your own risk and subject to the relevant provider's terms.",
      "Future tools, features, and services offered through the website will also be governed by these Terms of Service.",
    ],
  },
  {
    title: "Third-party links",
    paragraphs: [
      "The Service may contain third-party content or links. We do not control or guarantee third-party materials, websites, products, or services and are not responsible for evaluating their accuracy.",
      "Review a third party's terms and policies before entering a transaction. Concerns about third-party products or services should be directed to that provider.",
    ],
  },
  {
    title: "User comments and submissions",
    paragraphs: [
      "If you send comments, ideas, proposals, plans, or other material, you allow us to edit, copy, publish, distribute, translate, and use that material in any medium without restriction. We are not required to keep comments confidential, pay compensation, or respond.",
      "We may monitor, edit, or remove material we consider unlawful, offensive, threatening, defamatory, obscene, or otherwise objectionable. Your submissions must not violate another person's rights, contain unlawful material or malware, use a false identity, or misrepresent their origin. You are responsible for your comments and their accuracy.",
    ],
  },
  {
    title: "Personal information",
    paragraphs: [
      "Personal information submitted through the website is handled according to our Privacy Policy.",
    ],
  },
  {
    title: "Errors and omissions",
    paragraphs: [
      "The website or Service may occasionally contain errors relating to descriptions, pricing, promotions, charges, timing, or availability. We may correct errors, update information, or cancel orders at any time, including after an order is submitted.",
      "Except where law requires it, we have no general obligation to update or clarify information. A displayed update date does not necessarily mean all site information has been revised.",
    ],
  },
  {
    title: "Prohibited uses",
    paragraphs: [
      "You may not use the site for unlawful acts; infringement; harassment, abuse, discrimination, or defamation; false information; malicious code; tracking others; spam, phishing, scraping, or similar activity; obscene purposes; or interference with security features. We may terminate access for prohibited use.",
    ],
  },
  {
    title: "Disclaimer and limitation of liability",
    paragraphs: [
      "We do not guarantee that the Service will always be uninterrupted, timely, secure, error-free, accurate, or reliable. It may be suspended or cancelled without notice. Use of the Service and products delivered through it is at your own risk and, unless expressly stated otherwise, is provided as available without implied warranties.",
      "To the fullest extent permitted by law, MAXXTEK SOLUTIONS and its directors, employees, affiliates, agents, contractors, suppliers, service providers, and licensors are not liable for direct, indirect, incidental, punitive, special, or consequential losses arising from use of the Service, its content, or products obtained through it. Where such exclusions are restricted, liability is limited to the maximum lawful extent.",
    ],
  },
  {
    title: "Indemnification",
    paragraphs: [
      "You agree to indemnify and hold harmless MAXXTEK SOLUTIONS and its related entities, partners, officers, agents, contractors, licensors, service providers, suppliers, interns, and employees against third-party claims arising from your breach of these terms, incorporated documents, applicable law, or third-party rights.",
    ],
  },
  {
    title: "Severability",
    paragraphs: [
      "If any part of these terms is held unlawful, void, or unenforceable, it will be enforced to the fullest lawful extent and treated as severed without affecting the remaining provisions.",
    ],
  },
  {
    title: "Termination",
    paragraphs: [
      "Rights and obligations arising before termination survive. You may end these terms by notifying us that you no longer wish to use the Service or by ceasing use of the site.",
      "If we believe you have not complied with these terms, we may terminate the agreement without notice, deny access to all or part of the Service, and require payment of amounts due through the termination date.",
    ],
  },
  {
    title: "Entire agreement",
    paragraphs: [
      "These terms and related policies constitute the entire agreement governing use of the Service and replace prior agreements or communications. Failure to enforce a provision is not a waiver, and ambiguities will not automatically be interpreted against the drafting party.",
    ],
  },
  {
    title: "Governing law",
    paragraphs: [
      "These Terms of Service and separate Service agreements are governed by the laws of India and the jurisdiction of Jalalpur, Uttar Pradesh.",
    ],
  },
  {
    title: "Changes to these terms",
    paragraphs: [
      "The current version of these terms is available on this page. We may update or replace any part by posting changes to the website. You are responsible for checking for updates, and continued use after publication means you accept the changes.",
    ],
  },
  {
    title: "Contact information",
    paragraphs: [
      "Questions about these Terms of Service should be sent to sj135637@gmail.com.",
    ],
  },
];

const Terms = () => (
  <LegalPage
    eyebrow="Service agreement"
    title="Terms of Service"
    intro={intro}
    sections={sections}
  />
);

export default Terms;
